import React, { useState, useEffect, useCallback } from 'react';
import ActivityResultStyled from './ActivityResultStyled';
import { useTheme, Box, TextField } from '@material-ui/core';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
// import { useSelector } from 'dva';
// import { history } from 'umi';
import Member from '@/assets/img/ecco/member.png';
import CycleChangeML from '@/components/CycleChangeML/index';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts';
import { LineChart } from 'echarts/charts';
import { TitleComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import LinearProgressML from '@/components/LinearProgressML/index';
import dayjs from 'dayjs';
import FirstPagedIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import { fmtThousand } from '@/utils/comUtil';

echarts.use([TitleComponent, CanvasRenderer, LineChart]);

const ActivityResult = () => {
  const [echartsOptions, setEchartsOptions] = useState({});
  const [page, setPage] = useState();
  const totalPage = 10;

  const getOption = useCallback(() => {
    let xData = [];
    for (let index = 7; index > 0; index--) {
      xData.push(dayjs().subtract(index, 'day').format('YYYY-MM-DD'));
    }
    // let seriesData1 = [];
    // let seriesData2 = [];
    // const result = mulTimeDimensionMulIndexMulValue(data || []);
    // if (type === 'WEEK') {
    //   for (let index = 7; index > 0; index--) {
    //     xData.push(dayjs().subtract(index, 'day').format('YYYY-MM-DD'));
    //   }
    // } else {
    //   for (let index = 30; index > 0; index--) {
    //     xData.push(dayjs().subtract(index, 'day').format('YYYY-MM-DD'));
    //   }
    // }
    // xData.forEach((e) => {
    //   const allMemberItem = result[type]?.ALL_MEMBER?.find(
    //     (s) => s.LABEL === e,
    //   ) || { VALUE: 0 };
    //   seriesData1.push(allMemberItem.VALUE);
    //   const activeMemberItem = result[type]?.ACTIVE_MEMBER?.find(
    //     (s) => s.LABEL === e,
    //   ) || { VALUE: 0 };
    //   seriesData2.push(activeMemberItem.VALUE);
    // });
    let option = {
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        show: true,
        // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine'],
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xData,
      },
      yAxis: {
        type: 'value',
      },
      textStyle: {
        // fontSize: chartsFontSize.s03,
        // fontFamily: fontFamily,
      },
      // tooltip: {
      //   trigger: 'axis',
      //   textStyle: {
      //     // fontSize: chartsFontSize.s03,
      //   },
      // },
      // legend: {
      //   // data: [
      //   //   formatMessage({ id: 'ec.dashboard.c02.lbl02' }),
      //   //   formatMessage({ id: 'ec.dashboard.c02.lbl03' }),
      //   // ],
      //   itemWidth: 10,
      //   itemHeight: 10,
      //   top: 0,
      //   icon: 'rect',
      // },
      // grid: {
      //   top: 35,
      //   left: 24,
      //   right: 24,
      //   bottom: 10,
      //   containLabel: true,
      // },
      // xAxis: {
      //   type: 'category',
      //   // data: xData, //['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      //   axisLabel: {
      //     // color: charts.xColor, //坐标值得具体的颜色
      //     // fontSize: chartsFontSize.s03,
      //     // interval: function () {
      //     //   return true;
      //     // },
      //   },
      //   // axisTick: false,
      //   axisLine: {
      //     lineStyle: {
      //       // color: charts.axisLineColor,
      //     },
      //   },
      // },
      // yAxis: [
      //   {
      //     type: 'value',
      //     axisTick: false,
      //     axisLine: false,
      //     axisLabel: {
      //       // color: charts.yColor, //坐标值得具体的颜色
      //       // fontSize: chartsFontSize.s03,
      //       // formatter: function (p) {
      //       //   return fmtThousand(p);
      //       // },
      //     },
      //     splitLine: {
      //       // show: false, //去除网格线
      //       lineStyle: {
      //         // color: charts.axisLineColor,
      //       },
      //     },
      //     // name: '新/活',
      //     // nameRotate: 45,
      //     // nameGap: 15,
      //     nameTextStyle: {
      //       // color: charts.yColor,
      //     },
      //     min: 0,
      //   },
      // ],
      // color: charts.lineColorList,
      // color: charts.lineColorAreaList,
      // series: seriesData,
      series: [
        {
          // name: formatMessage({ id: 'ec.dashboard.c02.lbl02' }),
          name: '注册人数',
          type: 'line',
          // data: data[type].newMembers,
          // data: seriesData1,
          data: [120, 132, 101, 134, 90, 230, 210],
          // smooth: true,
          yAxisIndex: 0,
          lineStyle: {
            width: 2.5,
          },
          showSymbol: true,
          color: '#EE6666',
          emphasis: {
            focus: 'series',
          },
        },
        {
          // name: formatMessage({ id: 'ec.dashboard.c02.lbl02' }),
          type: 'line',
          name: 'PV（活动页）',
          // data: data[type].newMembers,
          // data: seriesData1,
          data: [100, 112, 121, 104, 110, 170, 240],
          // smooth: true,
          yAxisIndex: 0,
          lineStyle: {
            width: 2.5,
          },
          showSymbol: true,
          color: '#5470C6',
          emphasis: {
            focus: 'series',
          },
        },
        {
          // name: formatMessage({ id: 'ec.dashboard.c02.lbl03' }),
          yAxisIndex: 0,
          name: 'UV（活动页）',
          type: 'line',
          data: [220, 182, 191, 234, 290, 330, 310],
          // data: seriesData2,
          // smooth: true,
          showSymbol: true,
          lineStyle: {
            width: 2.5,
          },
          color: '#91CB76',
          emphasis: {
            focus: 'series',
          },
        },
        {
          // name: formatMessage({ id: 'ec.dashboard.c02.lbl03' }),
          yAxisIndex: 0,
          name: '活动人数',
          type: 'line',
          data: [230, 102, 231, 193, 200, 320, 330],
          // data: seriesData2,
          // smooth: true,
          showSymbol: true,
          lineStyle: {
            width: 2.5,
          },
          color: '#FAC858',
          emphasis: {
            focus: 'series',
          },
        },
      ],
    };
    return option;
  }, []);

  useEffect(() => {
    setEchartsOptions(getOption());
  }, [getOption]);
  // const {
  //   setPageData,
  //   pagination,
  // } = props;
  // const pageData = props.pageData;
  // const dispatch = useDispatch();
  const theme = useTheme();

  // const [type, setType] = useState('WEEK');

  // const viewList = useSelector((state) => state.adjustmentData.viewList);

  // const loadingEffect = useSelector((state) => state.loading);
  // const loading = loadingEffect.effects['adjustmentData/getViewList'];

  // const { data, total } = viewList || {};

  const userData = [
    {
      title: '总注册人数',
      register: '54323435',
      today: '588',
    },
    {
      title: '总参与人数',
      register: '54323435',
      today: '1700',
    },
    {
      title: '总分享人数',
      register: '54323435',
      today: '432',
    },
  ];

  // 优惠券统计
  const couponData = [
    {
      title: '优惠券领取总数',
      register: '54323435',
      today: '588',
    },
    {
      title: '优惠券核销总数',
      register: '54323435',
      today: '588',
    },
  ];

  // 销售统计
  const saleData = [
    {
      title: '销售金额',
      register: '54323435',
      today: '588',
    },
  ];

  const changeType = () => {
    // setType(v);
  };

  const activityData = [
    {
      num: '1',
      title: 'UV（活动页）转化率',
      percent: '80',
      numTitle: 'UV（活动页）人数：',
      peopleNum: '6498',
      color: '#91CB76',
    },
    {
      num: '2',
      title: '参与转化率',
      percent: '32',
      numTitle: '分享人数：',
      peopleNum: '2344',
      color: '#FAC858',
    },
    {
      num: '3',
      title: '注册转化率',
      percent: '28',
      numTitle: '参与活动人数：',
      peopleNum: '1333',
      color: '#5470C6',
    },
    {
      num: '4',
      title: '分享转化率',
      percent: '10',
      numTitle: '注册人数：',
      peopleNum: '295',
      color: '#EE6666',
    },
  ];

  return (
    <ActivityResultStyled theme={theme}>
      <div className="activity-num-wrap">
        <Box className="user-statistics-wrap statistics-wrap-first">
          <div className="user-statistics-title">
            <SvgIconML
              size={21}
              className="icon"
              name={'emp_analysis'}
            ></SvgIconML>
            <span>用户统计</span>
          </div>
          <div className="user-statistics-content">
            {userData &&
              userData.map((item) => (
                <Box>
                  <div className="statistics-content-title">{item.title}</div>
                  <div className="statistics-content-register">
                    {fmtThousand(item.register)}
                  </div>
                  <div>
                    <span className="statistics-content-title">今日</span>
                    <span className="statistics-content-today">
                      {fmtThousand(item.today)}
                    </span>
                  </div>
                </Box>
              ))}
          </div>
        </Box>
        <div className="statistics-wrap-right">
          <Box className="user-statistics-wrap">
            <div className="user-statistics-title">
              <SvgIconML
                size={21}
                className="icon"
                name={'scene-coupon'}
              ></SvgIconML>
              <span>优惠券统计</span>
            </div>
            <div className="user-statistics-content">
              {couponData &&
                couponData.map((itm) => (
                  <Box>
                    <div className="statistics-content-title">{itm.title}</div>
                    <div className="statistics-content-register">
                      {fmtThousand(itm.register)}
                    </div>
                    <div>
                      <span className="statistics-content-title">今日</span>
                      <span className="statistics-content-today">
                        {fmtThousand(itm.today)}
                      </span>
                    </div>
                  </Box>
                ))}
            </div>
          </Box>
          <Box className="user-statistics-wrap">
            <div className="user-statistics-title">
              <SvgIconML
                size={21}
                className="icon"
                name={'scene-sale'}
              ></SvgIconML>
              <span>销售统计</span>
            </div>
            <div className="user-statistics-content">
              {saleData &&
                saleData.map((i) => (
                  <Box>
                    <div className="statistics-content-title">{i.title}</div>
                    <div className="statistics-content-register">
                      {fmtThousand(i.register)}
                    </div>
                    <div>
                      <span className="statistics-content-title">今日</span>
                      <span className="statistics-content-today">
                        {fmtThousand(i.today)}
                      </span>
                    </div>
                  </Box>
                ))}
            </div>
          </Box>
        </div>
      </div>

      {/* 图表 */}
      <div className="activity-echarts-wrap">
        <Box className="echarts-wrap">
          <div className="right-echarts-title">
            <div className="echarts-title-left">
              <img src={Member} alt="" srcset="" />
              <div className="title-left-center">
                <span>大转盘活动用户数</span>
                <span>2021-01-01 ~ 2021-01-07</span>
              </div>
            </div>
            <div className="echarts-title-right">
              <FirstPagedIcon
                className={page > totalPage ? 'noLastPage' : 'lastPage'}
              />
              当前第
              <TextField
                variant="standard"
                id="outlined-multiline-static"
                autoComplete="off"
                value={page}
                placeholder=""
                className="basic-name"
                onChange={(e) => {
                  setPage(e.target.value);
                }}
                // InputProps={{
                //   endAdornment: (
                //     <InputAdornment position="end">
                //       <IconButton
                //         className="clear-btn"
                //         onClick={() => {
                //           setTitle('');
                //           setValue('title', '');
                //         }}
                //         edge="end"
                //         disabled={opt === 'detail'}
                //       >
                //         {title && <ClearIcon className="clear-icon" />}
                //       </IconButton>
                //     </InputAdornment>
                //   ),
                // }}
              />
              /{totalPage}周
              <LastPageIcon
                className={page > totalPage ? 'noLastPage' : 'lastPage'}
              />
            </div>
          </div>
          <Box className="user-echarts-wrap">
            <ReactEChartsCore
              echarts={echarts}
              lazyUpdate={true}
              option={echartsOptions || {}}
              notMerge={true}
              style={{ width: '100%' }}
              showLoading={false}
            />
          </Box>
        </Box>
        <Box className="echarts-wrap">
          <div className="right-echarts-title">
            <div className="echarts-title-left">
              <span className="title-left-funnelPlot">
                <SvgIconML
                  size={24}
                  className="icon"
                  name={'funnelPlot'}
                ></SvgIconML>
              </span>
              <div className="title-left-center">
                <span>大转盘活动漏斗</span>
                <span>2021-01-01 ~ 2021-01-07</span>
              </div>
            </div>
            <div>
              <CycleChangeML
                typeList={[
                  { label: '全部', value: '7D' },
                  { label: '昨日', value: '30D' },
                ]}
                change={changeType}
              />
            </div>
          </div>
          <Box className="barline-wrap-top">
            {activityData &&
              activityData.map((item) => (
                <>
                  <div className="barline-wrap">
                    <div className="barline-left-wrap">
                      <div>
                        <span className="barline-left-num">{item.num}</span>
                        <span className="barline-left-title">{item.title}</span>
                      </div>
                      <span>{item.percent}%</span>
                    </div>
                    <div className="barline-right-wrap">
                      <span>{item.numTitle}</span>
                      <span>{item.peopleNum}</span>
                    </div>
                  </div>
                  <LinearProgressML
                    value={item.percent}
                    color={item.color}
                  ></LinearProgressML>
                </>
              ))}
          </Box>
        </Box>
      </div>
    </ActivityResultStyled>
  );
};

export default ActivityResult;
